import {
  AddressApiSuccessResponse,
  houseNumberError,
  IGraphProvider,
} from '../../';
import { HouseDataResponse } from './travel/types';
import { getHouseDataQuery } from '../queries';
import { gql } from '@apollo/client';
import { getComparatorConfigQuery } from '../queries/getComparatorConfig';

export const validateAddressCommon = (
  graphProvider: IGraphProvider,
  variables
): Promise<AddressApiSuccessResponse> => {
  return new Promise<AddressApiSuccessResponse>((resolve, reject) => {
    graphProvider
      .query<HouseDataResponse>(
        gql(getHouseDataQuery),
        variables,
        'simpleAddressData',
        'network-only',
        `${process.env.KIZI_PUBLIC_DOMAIN}/housedata/graphql`
      )
      .then((data: HouseDataResponse) => {
        if (data && data.postalCode) {
          resolve({
            city: data.place ?? '',
            street: data.street ?? '',
            houseNumber: (data.houseNumber ?? '').toString(),
            addition: (data.houseNumberAddition ?? '').toString(),
            postcode: data.postalCode ?? '',
            fullAddress: `${data.street} ${
              data.houseNumber + (data.houseNumberAddition || '')
            } ${data.postalCode}, ${data.place}`,
          });
        } else {
          reject(houseNumberError);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getComparatorConfigCommon = (
  graphProvider: IGraphProvider,
  variables: {
    clientName: string;
    comparatorId: string;
  }
): Promise<any> => {
  return new Promise((resolve, reject) => {
    graphProvider
      .query<any>(
        gql(getComparatorConfigQuery),
        variables,
        'comparatorConfigs',
        'network-only',
        `${process.env.KIZI_PUBLIC_DOMAIN}/product/graphql`
      )
      .then((response) => {
        if (response) {
          resolve(response);
        } else {
          reject(new Error('No response received'));
        }
      })
      .catch((error) => {
        console.error('Error in getComparatorConfigCommon:', error);
        reject(error);
      });
  });
};
